module.exports = __webpack_public_path__ + "static/EUR-50-front-160fea45e379f1250dfe4ae07187e9a7.png";